const FMT_PEN = new Intl.NumberFormat('es-PE', { style: 'currency', currency: 'PEN' })
const FMT_USD = new Intl.NumberFormat('es-PE', { style: 'currency', currency: 'USD' })
const FMT_FECHA = new Intl.DateTimeFormat('es-PE', { dateStyle: 'medium' })

export function moneda(valor: number | string | null, codigo: 'PEN' | 'USD' = 'PEN'): string {
  if (valor === null) return '—'
  const n = typeof valor === 'string' ? Number(valor) : valor
  return (codigo === 'USD' ? FMT_USD : FMT_PEN).format(n)
}

/**
 * Fechas sin hora ('2026-08-25').
 *
 * `new Date('2026-08-25')` las interpreta como medianoche UTC, y al formatear
 * en Lima (UTC−5) retrocede un día: el 25 se muestra como 24. Por eso se
 * construye la fecha con sus partes, que sí es local.
 */
export function fecha(valor: string | Date | null): string {
  if (!valor) return '—'
  if (valor instanceof Date) return FMT_FECHA.format(valor)

  const soloFecha = /^(\d{4})-(\d{2})-(\d{2})$/.exec(valor)
  if (soloFecha) {
    const [, a, m, d] = soloFecha
    return FMT_FECHA.format(new Date(Number(a), Number(m) - 1, Number(d)))
  }
  return FMT_FECHA.format(new Date(valor))
}

/** La fecha de hoy en zona local, para los valores por defecto de formularios. */
export function hoyLocal(): string {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

/** 20603256639 → 20-603256639, como se lee en los formatos impresos. */
export function ruc(valor: string | null): string {
  if (!valor) return '—'
  return `${valor.slice(0, 2)}-${valor.slice(2)}`
}

export function vacio(valor: string | null | undefined): string {
  return valor?.trim() ? valor : '—'
}
